import styled from '@emotion/styled';
import { kitopiColors } from '@kitopi-com/customer-auth';

// Success Container Styles
export const SuccessContainer = styled('div')<{
  titleFontSize: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  h2 {
    color: ${kitopiColors.kitopiWhite};
    text-align: center;
    font-size: ${({ titleFontSize }) => titleFontSize};
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  p {
    color: ${kitopiColors.kitopiWhite};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
  }
`;
